import { render, staticRenderFns } from "./AcademicProgressViewAmend.vue?vue&type=template&id=40881024&scoped=true&"
import script from "./AcademicProgressViewAmend.vue?vue&type=script&lang=js&"
export * from "./AcademicProgressViewAmend.vue?vue&type=script&lang=js&"
import style0 from "./AcademicProgressViewAmend.vue?vue&type=style&index=0&id=40881024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40881024",
  null
  
)

export default component.exports